import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getBonusHistoryList = (params) => {
    return axios.get(`${backendHost}/api/admin/bonuses/history/list`, {params});
};

export {
    getBonusHistoryList
}